import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Reads admin-editable copy for a marketing page (see backend/page_cms.py). Every page still ships
// its original strings as fallbacks, so it renders even if this store is empty/unreachable.
//   const { get, img } = usePageContent("about");
//   <h1><AccentText text={get("heading", "BUILT FOR THE\n*OPTICS TRADE.*")} /></h1>
export function usePageContent(pageKey) {
  const [values, setValues] = useState({});

  useEffect(() => {
    let alive = true;
    api.get(`/pages/${pageKey}`)
      .then(({ data }) => { if (alive) setValues(data?.values || {}); })
      .catch(() => {});
    return () => { alive = false; };
  }, [pageKey]);

  // A stored value only wins when it's a non-empty string; otherwise the page's own fallback shows.
  const get = (key, fallback = "") => {
    const v = values[key];
    return typeof v === "string" && v.trim() !== "" ? v : fallback;
  };
  const img = (key, fallback = "") => {
    const v = values[key];
    return typeof v === "string" && v.trim() !== "" ? v : fallback;
  };

  return { values, get, img };
}

// Renders CMS heading text: `*word*` -> accent-colored span, `\n` -> line break.
// The accent styling is passed by the host so each page keeps its own accent (class or inline style).
export function AccentText({ text, accentClassName = "text-olive-bright", accentStyle }) {
  const lines = String(text || "").split("\n");
  return (
    <>
      {lines.map((line, li) => (
        <React.Fragment key={li}>
          {li > 0 && <br />}
          {line.split(/(\*[^*]+\*)/g).filter(Boolean).map((part, pi) => {
            if (part.startsWith("*") && part.endsWith("*") && part.length > 1) {
              return (
                <span key={pi} className={accentStyle ? undefined : accentClassName} style={accentStyle}>
                  {part.slice(1, -1)}
                </span>
              );
            }
            return <React.Fragment key={pi}>{part}</React.Fragment>;
          })}
        </React.Fragment>
      ))}
    </>
  );
}
